import { Component } from '@angular/core';

@Component({
  templateUrl: './verification.component.html',
  styleUrls: ['./verification.component.css'],
})
export class VerificationComponent {
  constructor(
  ) {
  }

}
